import { wrapper, createApiClient, Result, ApiError } from "../base";
import FileTagDTO = App.Data.FileTagDTO;

const basePath = `file-tags`;
const baseClient = createApiClient();

export default class {
	getFileTags(): Promise<Result<FileTagDTO[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}`));
	}

	/** Without a colour the backend hands out the next one in its palette. */
	createFileTag(
		name: string,
		rgbColorValue?: string | null
	): Promise<Result<FileTagDTO, ApiError>> {
		return wrapper(
			baseClient.post(`${basePath}`, {
				name,
				rgb_color_value: rgbColorValue ?? undefined,
			})
		);
	}

	/** Name and colour live on the tag, so this shows on every file using it. */
	updateFileTag(
		id: number,
		changes: { name?: string; rgb_color_value?: string }
	): Promise<Result<FileTagDTO, ApiError>> {
		return wrapper(baseClient.patch(`${basePath}/${id}`, changes));
	}

	/** Deletes the tag outright, so it also leaves every file carrying it. */
	deleteFileTag(id: number): Promise<Result<[], ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${id}`));
	}
}
